/**
 * Protected Route Components for ProfitSpot
 * Handles authentication and authorization checks
 */
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PremiumWall from './PremiumWall';

/**
 * AdminRoute - Only accessible by users with admin role
 */
export const AdminRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuth();
  
  // Wait for auth state to initialize before redirecting
  if (loading) return null;
  
  const isAdmin = user?.role === 'admin';
  
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

/**
 * PremiumRoute - Only accessible by Pro/Unlimited subscribers
 * Shows premium wall for unauthorized users instead of redirecting
 */
export const PremiumRoute = ({ children, featureName = 'Premium Feature' }) => {
  const { user, isAuthenticated, loading } = useAuth();
  
  // Wait for auth state to initialize
  if (loading) return null;
  
  const userTier = user?.subscription?.tier || 'free';
  const isPremium = userTier === 'pro' || userTier === 'unlimited';
  
  // Show premium wall if not authenticated OR not premium
  if (!isAuthenticated || !isPremium) {
    return <PremiumWall feature={featureName} />;
  }
  
  return children;
};
